import { render, staticRenderFns } from "./EmployeeListSimple.vue?vue&type=template&id=5896e217&scoped=true&"
import script from "./EmployeeListSimple.vue?vue&type=script&lang=ts&"
export * from "./EmployeeListSimple.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeListSimple.vue?vue&type=style&index=0&id=5896e217&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5896e217",
  null
  
)

export default component.exports